<template>
  <div class="tw:flex tw:flex-col tw:md:flex-row tw:gap-4 tw:w-full">
    <PlusPerformanceCard
      class="tw:w-full tw:md:w-1/3"
      v-for="card in cardsData"
      :key="card.id"
      :icon="card.icon"
      :title="card.title"
      :hint="card.hint"
      :value="card.value"
    />
  </div>
</template>
<script setup>
import PlusPerformanceCard from '@/components/studioPlus/insights/PlusPerformanceCard.vue'

defineProps({
  cardsData: Array,
})
</script>
